/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryGroupSubscriptionOverview } from './LaundryGroupSubscriptionOverview';
import {
    LaundryGroupSubscriptionOverviewFromJSON,
    LaundryGroupSubscriptionOverviewFromJSONTyped,
    LaundryGroupSubscriptionOverviewToJSON,
} from './LaundryGroupSubscriptionOverview';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableLaundryGroupsSubscription
 */
export interface PageableLaundryGroupsSubscription {
    /**
     * 
     * @type {Array<LaundryGroupSubscriptionOverview>}
     * @memberof PageableLaundryGroupsSubscription
     */
    result: Array<LaundryGroupSubscriptionOverview>;
    /**
     * 
     * @type {Page}
     * @memberof PageableLaundryGroupsSubscription
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableLaundryGroupsSubscription interface.
 */
export function instanceOfPageableLaundryGroupsSubscription(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableLaundryGroupsSubscriptionFromJSON(json: any): PageableLaundryGroupsSubscription {
    return PageableLaundryGroupsSubscriptionFromJSONTyped(json, false);
}

export function PageableLaundryGroupsSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableLaundryGroupsSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(LaundryGroupSubscriptionOverviewFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableLaundryGroupsSubscriptionToJSON(value?: PageableLaundryGroupsSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(LaundryGroupSubscriptionOverviewToJSON)),
        'page': PageToJSON(value.page),
    };
}

